import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/esign/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { esignBaseQuery } from './baseQuery';

const FIVE_MINUTES = 5 * 60;

export const ESIGN_API_REDUCER_PATH = 'api/esign' as const;

export const esignApiRoot = createApi({
  reducerPath: ESIGN_API_REDUCER_PATH,
  baseQuery: esignBaseQuery,
  keepUnusedDataFor: FIVE_MINUTES,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
